<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>

   

    <div class="panel panel-danger  " >
    <div class="panel-heading ">
    <p class="encabezado">{{title}}</p>

</div>
<div class="panel-body">
<div class="row">
    <div class="col-sm-1" >
        <br>
        &nbsp; <span ><img  src="./assets/images/icon/lupa.png"  class="iconLupa" ></span>
    </div>
<div  class="col-sm-11">
    <mat-form-field appearance="standard">
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input>
    </mat-form-field>
</div>
</div>
<div class="row">
    <div class="container">
        <div class="col-sm-12 example-container">
    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource"  class=" table table-striped table-bordered">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">Código EC</th>
                <td mat-cell *matCellDef="let element" (click)="sectorByID(element)" class="letraE">{{element.codigoEC}} </td>
            </ng-container>

            <ng-container matColumnDef="descripcion">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua" >Nombre del EC</th>
                <td mat-cell *matCellDef="let element" (click)="sectorByID(element)" class="letraE">{{element.descripcion}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator
        showFirstLastButtons 
        aria-label="Select page of periodic elements">
</mat-paginator>
        <br>
       
    </div>
</div>
</div>
</div>
</div>
<br>

<div class="row">
    <div class="container">
<div class="col-sm-5" ></div>
<div style="text-align: center;" class="col-sm-1" >
<button mat-button (click) = "back()"><img src="./assets/images/icon/Atras.png"  class=" imagen" /></button>
</div>
<div style="text-align: center;"  class="col-sm-1">
<button mat-button (click) = "home()"><img src="./assets/images/icon/Home.png"  class=" imagen" /></button>
</div>
</div>
</div>
</div>

